import alertash from './alertash.png';
import alertcold from './alertcold.png';
import alertdust from './alertdust.png';
import alertflood from './alertflood.png';
import alertfog from './alertfog.png';
import alertfreeze from './alertfreeze.png';
import alertfrost from './alertfrost.png';
import alertheat from './alertheat.png';
import alerthurricane from './alerthurricane.png';
import alerticy from './alerticy.png';
import alertpollution from './alertpollution.png';
import alertsmoke from './alertsmoke.png';
import alertsnow from './alertsnow.png';
import alerttornado from './alerttornado.png';
import alerttropicalstorm from './alerttropicalstorm.png';
import alerttstorm from './alerttstorm.png';
import alertwindy from './alertwindy.png';

export const ALERTS_NON_PLATED_ICON_PATH_MAP = {
  alertash,
  alertcold,
  alertdust,
  alertflood,
  alertfog,
  alertfreeze,
  alertfrost,
  alertheat,
  alerthurricane,
  alerticy,
  alertpollution,
  alertsmoke,
  alertsnow,
  alerttornado,
  alerttropicalstorm,
  alerttstorm,
  alertwindy,
  '': undefined,
};
